import type {MiniStatusIconProps} from './mini-merge-sections/MiniStatusIcon'
import type {ProgressSegment} from './mini-merge-sections/MultiColorProgressBar'
import type {ThreadCounts} from '../../../../page-data/loaders/use-tab-counts'

export type CommentsProgressProjection = {
  blockingSummary?: string
  successful: number
  total: number
  isUnavailable: boolean
  icon: MiniStatusIconProps['type']
  progressLabel: string
  progressValueText?: string
  segments: readonly ProgressSegment[]
}

export function projectCommentsProgress(threadCounts: ThreadCounts | undefined): CommentsProgressProjection {
  const total = threadCounts?.totalThreads ?? 0
  const successful = threadCounts?.resolvedThreads ?? 0
  const open = threadCounts?.unresolvedThreads ?? 0
  const segments = total
    ? [
        segment('success', successful, total, 'resolved comment', 'comments-progress-resolved'),
        segment('attention', open, total, 'open comment', 'comments-progress-open'),
      ].filter(segmentValue => segmentValue !== undefined)
    : []

  return {
    blockingSummary: open > 0 ? `${open} unresolved ${open === 1 ? 'comment' : 'comments'}` : undefined,
    successful,
    total,
    isUnavailable: total === 0,
    icon: total === 0 ? 'empty' : open > 0 ? 'warning' : 'success',
    progressLabel: `${successful} of ${total} resolved comments`,
    progressValueText: segments.map(item => item.label).join(', ') || undefined,
    segments,
  }
}

function segment(
  color: ProgressSegment['color'],
  count: number,
  total: number,
  singularLabel: string,
  testId: string,
  pluralLabel: string = `${singularLabel}s`,
): ProgressSegment | undefined {
  if (count <= 0) return undefined
  return {
    color,
    id: testId,
    label: `${count} ${count === 1 ? singularLabel : pluralLabel}`,
    percentage: (count / total) * 100,
    testId,
  }
}
